import { memo, useCallback } from "react"
import { useSelector } from "react-redux"
import WearableCard from "@/components/WearableCard"
import { RootState } from "@/store"
import { selectUnknownLocationWearableById } from "@/store/unknownLocationWearablesSlice"
import { formatInmateName } from "@/utils/index"

interface UnknownLocationWearableCardProps {
   wearableId: string
   onSwapDeviceClick?: (wearableId: string) => void
   onNavigateToInmateDetail?: (inmateId: string) => void
   isExpanded?: boolean
   isCollapsed?: boolean
   onExpandedChange?: (wearableId: string, isExpanded: boolean) => void
}

const UnknownLocationWearableCard = ({
   wearableId,
   onSwapDeviceClick,
   onNavigateToInmateDetail,
   isExpanded,
   isCollapsed,
   onExpandedChange,
}: UnknownLocationWearableCardProps) => {
   const wearable = useSelector((state: RootState) =>
      selectUnknownLocationWearableById(state, wearableId)
   )

   const handleSwapDevice = useCallback(() => {
      onSwapDeviceClick?.(wearableId)
   }, [onSwapDeviceClick, wearableId])

   const handleViewDetails = useCallback(() => {
      if (wearable?.inmate?.id) {
         onNavigateToInmateDetail?.(wearable.inmate.id)
      }
   }, [onNavigateToInmateDetail, wearable?.inmate?.id])

   if (!wearable) {
      return null
   }

   const inmateName =
      wearable.inmate?.customIdentifier || formatInmateName(wearable.inmate)

   return (
      <WearableCard
         wearableId={wearable.id}
         inmateName={inmateName}
         bookingNumber={wearable.inmate?.bookingNumber}
         awaitingVitals
         onSwapDevice={handleSwapDevice}
         onViewDetails={handleViewDetails}
         isExpanded={isExpanded}
         isCollapsed={isCollapsed}
         onExpandedChange={(nextIsExpanded) =>
            onExpandedChange?.(wearable.id, nextIsExpanded)
         }
      />
   )
}

export default memo(UnknownLocationWearableCard)
